// App.js
import React, { useEffect, useState } from 'react';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import Chat from './components/Chat/Chat.js';
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/theme.js';
import LeftPanel from './components/LeftPanel/LeftPanel.js';
import { TOKENS } from './config/tokens.js';
import './styles/css/App.css';

const App = ({ config }) => {
  const [userMessage, setUserMessage] = useState('');
  
  // Get configuration from props (passed via window.AiAgent.init) or from global config or TOKENS
  const appConfig = React.useMemo(() => config || window.__AI_AGENT_CONFIG__ || {}, [config]);
  
  // Get user language and host from config
  const userLanguage = appConfig.user_language || TOKENS.USER_LANGUAGE || 'en'; // ru, ua, en
  const host = appConfig.host_api || null;

  // Update TOKENS with config values if provided
  useEffect(() => {
    if (appConfig.user_language) {
      TOKENS.USER_LANGUAGE = appConfig.user_language;
    }
  }, [appConfig]);

  const handleButtonClick = (text) => {
    setUserMessage(text);
  };

  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <div className="app-container">
          <LeftPanel onButtonClick={handleButtonClick} language={userLanguage} />

          <div className="app-main-content">
            <h1 className="app-title">AI Chat</h1>
            <Chat
              userMessage={userMessage}
              setUserMessage={setUserMessage}
              userLanguage={userLanguage}
              host={host}
            />
          </div>
        </div>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
};

export default App;
